import { render, staticRenderFns } from "./ActivityAssigned.vue?vue&type=template&id=349dc1f4&scoped=true&lang=pug&"
import script from "./ActivityAssigned.vue?vue&type=script&lang=js&"
export * from "./ActivityAssigned.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAssigned.vue?vue&type=style&index=0&id=349dc1f4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349dc1f4",
  null
  
)

export default component.exports